import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

function ProfileVerify(props) {
    const history = useHistory();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        if (verified === false) {
            if (currentAuth !== null && currentAuth.token.profile.length > 0 && currentAuth.token.profile.filter(x => x === "sAdmin" || x === "Admin").length === 0) {
                history.push({
                    pathname: `/`,
                })
            }
            else {
                setVerified(true);
            }
        }        
    }, [verified, currentAuth]);

    return (<></>);
}

export default ProfileVerify;


